import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_SECADA_2_MAS } from '../../../../config/tables'

function TablaDetalleSecadaDosMasView () {
  return (
    <MuiTable id={TABLA_DETALLE_SECADA_2_MAS} />
  )
}

export default TablaDetalleSecadaDosMasView
